import React from "react";
import { useNavigate, useParams } from "react-router-dom"
import { Gallery } from "../../../models/gallery.model";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/root.reducer";
import { JsonEditor } from "json-edit-react";
import { useDispatch } from "react-redux";
import { CreateGallery, GetGalleries, UpdateGallery } from "../store/admin.actions";

export const EditGallery = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const galleries: Gallery[] = useSelector((state: AppState) => state.admin.galleries);
    const g = galleries.find(g => g._id === params["galleryId"])
    
    const [ gallery, setGallery ] = React.useState<any>(g ? {...g, user: g.user._id} : {})

    React.useEffect(() => {
        (async () => {
            dispatch(GetGalleries());
        })();
    }, []);

    React.useEffect(() => {
        const g = galleries.find(g => g._id === params["galleryId"])
        setGallery(g ? {...g, user: g.user._id} : {})
    }, [galleries])

    const saveGallery = async () => {
        if (params["galleryId"])  {
            // update
            dispatch(UpdateGallery({gallery, navigate}));
        } else {
            dispatch(CreateGallery({gallery, navigate}))
        }
    }

    return (
        <div className="container">
            <button onClick={saveGallery}>Save</button>
            <JsonEditor
                data={gallery}
                onUpdate={({newData}) => {
                    setGallery(newData)
                }}
                className=""
            />
        </div>
    )
}